import React, { useEffect, useState } from "react";
import { Link } from "gatsby";
import { GA4_ID, getStoredConsent, setConsent } from "../lib/consent";

// Baner zgody na cookies — styl spójny z resztą strony (Editorial Precision):
// karta bg-card, jeden akcent #8B5CF6, dark/light, animacja wjazdu od dołu.
//
// Logika:
// - Pokazuje się tylko gdy (a) skonfigurowano GA4 (GATSBY_GA4_ID) ORAZ
//   (b) user jeszcze nie podjął decyzji (brak wpisu w localStorage).
// - "Akceptuję" → consent granted (GA zaczyna śledzić). "Odrzucam" → denied.
// - Decyzja zapamiętana, więc baner nie wraca przy kolejnych wizytach.
const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Bez Measurement ID nie zbieramy żadnych danych → baner zbędny.
    if (!GA4_ID) return;
    if (getStoredConsent() === null) setVisible(true);
  }, []);

  const decide = (value: "granted" | "denied") => {
    setConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-label="Zgoda na pliki cookies"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-[100] flex justify-center px-4 pb-4 sm:px-6 sm:pb-6 animate-fade-in-up"
    >
      <div className="cookie-card w-full max-w-3xl rounded-2xl border border-border-strong bg-bg-card/95 backdrop-blur-md shadow-card p-5 sm:p-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
          <div className="max-w-xl">
            <p className="font-display text-sm font-semibold tracking-tight text-ink">
              Używamy plików cookies
            </p>
            <p className="mt-1.5 text-sm leading-relaxed text-ink-muted">
              Korzystamy z Google Analytics, aby zrozumieć, jak odwiedzasz tę stronę,
              i ją ulepszać. Analityka uruchamia się dopiero po Twojej zgodzie.
              Szczegóły znajdziesz w{" "}
              <Link
                to="/polityka-prywatnosci"
                className="link-underline text-accent-glow hover:text-accent-violet transition-colors"
              >
                polityce prywatności
              </Link>
              .
            </p>
          </div>

          <div className="flex shrink-0 flex-col-reverse gap-3 sm:flex-row md:flex-col-reverse lg:flex-row">
            <button
              type="button"
              onClick={() => decide("denied")}
              className="btn-ghost px-5 py-2.5 text-sm whitespace-nowrap"
            >
              Odrzucam
            </button>
            <button
              type="button"
              onClick={() => decide("granted")}
              className="btn-primary px-5 py-2.5 text-sm whitespace-nowrap"
            >
              Akceptuję
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
